// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container{width:80%;max-width:600px}input[type=range]{width:100%;margin-bottom:20px}.progress-bar{width:100%;height:5px;background-color:#007bff;transition:background-color .3s}", ""]);
// Exports
module.exports = exports;
